define('editor/edit/map/controls/directions',['durandal/app', 'knockout'], function (app, ko) {
    var control = function (options) {
        var self = this;

        self.options = options;
        self.layer = options.layer;
        self.mapControl = self.options.mapControl;
        self.featureGroup = null;
        self.isEditing = false;

        self.defaultStrokeColor = '#0247FE';
        self.defaultStrokeWeight = 5;
        self.defaultStrokeOpacity = 0.5;

        self.addToMap = function () {
            if (self.options.layer.visible()) {
                self.featureGroup = self.buildFeatureGroup(self.layer.state());
                self.featureGroup.addTo(self.mapControl);
                app.on('directions:composing', function () {
                    for (var stamp in self.featureGroup._layers) {
                        var layer = self.featureGroup._layers[stamp];
                        if (layer._icon) {
                            layer.unbindPopup();
                        }
                    }
                });

                app.on('directions:complete', function () {
                    for (var stamp in self.featureGroup._layers) {
                        var layer = self.featureGroup._layers[stamp];
                        if (layer._icon) {
                            layer.bindPopup(layer.options.title, {
                                offset: new L.Point(0, -30)
                            });
                        }
                    }
                });
            }
        };

        self.buildFeatureGroup = function (state) {
            var featureGroup,
                points = state.points,
                polyOptions = {
                  color: state.strokeColor ? state.strokeColor : self.defaultStrokeColor ,
                  opacity: state.strokeOpacity ? state.strokeOpacity : self.defaultStrokeOpacity,
                  weight: state.strokeWeight ? state.strokeWeight : self.defaultStrokeWeight
                },
                polyline = L.polyline(points, polyOptions),
                markersLen = state.waypoints.length,
                markers = [];

            for (var i = 0; i < markersLen; i++) {
                var marker,
                    waypoint = state.waypoints[i],
                    iconOptions = {
                        iconAnchor: [15, 35],
                        className: 'marker-icon',
                        mfIconName: waypoint.icon,
                        draggable: false,
                        clickable: false,
                        html: '',
                        paddleVisible: waypoint.paddleVisible,
                        paddleColor: waypoint.paddleColour,
                        iconColour: waypoint.iconColour,
                        iconSize: waypoint.iconSize
                    };

                if (!waypoint.icon) {
                  // set defaults, if layer state does not specify an icon
                  if (i === 0 && !iconOptions.mfIconName) {
                    iconOptions.mfIconName = '/content/icons/default/Markers/start.svg';
                    iconOptions.paddleVisible = true;
                    iconOptions.paddleColor = '#0AA54A';
                    iconOptions.iconColour = '#FFFFFF';
                  } else if (i === markersLen - 1 && !iconOptions.mfIconName) {
                    iconOptions.mfIconName = '/content/icons/default/Markers/end.svg';
                    iconOptions.paddleVisible = true;
                    iconOptions.paddleColor = '#0AA54A';
                    iconOptions.iconColour = '#FFFFFF';
                  } else if (!iconOptions.mfIconName) {
                    iconOptions.mfIconName = '/content/icons/default/Markers/capitalcity_02.svg';
                    iconOptions.paddleVisible = true;
                    iconOptions.paddleColor = '#808080';
                    iconOptions.iconColour = '#FFFFFF';
                  }
                }

                var svg = '';
                var isSvg = iconOptions.mfIconName.endsWith('.svg');
                var markerStyle = ';width:43px;margin-left:-10px;margin-top:-3px;';
                var iconStyle = ';width:43px;margin-left:-10px;margin-top:-3px;';

                switch (iconOptions.iconSize) {
                  case 'small':
                    iconOptions.iconSize = [15, 21];
                    markerStyle = ';width:30px;margin-left:-3px;margin-top:10px;';
                    iconStyle = iconOptions.paddleVisible ? ';width:15px;margin-top:13px;margin-left:5px;' : markerStyle;
                    break;
                  case 'large':
                    iconOptions.iconSize = [40, 47];
                    markerStyle = ';width: 56px;margin-left: -17px;margin-top: -15px;';
                    iconStyle = iconOptions.paddleVisible ? ';width:30px;margin-top: -10px;margin-left: -4px;' : ';width: 35px;margin-top: 10px;margin-left:3px;';
                    break;
                  case 'xlarge':
                    iconOptions.iconSize = [50, 60];
                    markerStyle = ';width: 70px;margin-left: -24px;margin-top: -28px;';
                    iconStyle = iconOptions.paddleVisible ? ';width: 40px;margin-top: -23px;margin-left: -9px;' : ';width: 46px;margin-top: 10px;margin-left: 3px;';
                    break;
                  case 'xxlarge':
                    iconOptions.iconSize = [60, 75];
                    markerStyle = ';width: 86px;margin-left: -32px;margin-top: -44px;';
                    iconStyle = iconOptions.paddleVisible ? ';width: 49px;margin-top: -37px;margin-left: -13px;' : ';width: 57px;margin-top: 16px;margin-left: 2px;';
                    break;
                  default:
                    iconStyle = iconOptions.paddleVisible ? ';width:24px;' : markerStyle;
                    break;
                }

                if (iconOptions.paddleVisible) {
                  svg += '<svg viewBox="0 0 32 32" style="fill:' + iconOptions.paddleColor + markerStyle + '">';
                  svg += '<use xlink:href="/content/img/icons/marker.svg#Layer_1"></use>';
                  svg += '</svg>';
                }

                svg += '<svg viewBox="0 0 32 32" style="fill:' + iconOptions.iconColour + iconStyle + '">';
                svg += '<use xlink:href="' + iconOptions.mfIconName + '#Layer_1"></use>';
                svg += '</svg>';

                iconOptions.html = !isSvg ? '<img src=\"' + iconOptions.mfIconName + '\" />' : svg;

                marker = L.marker([waypoint.latLng.lat, waypoint.latLng.lng], {
                    title: waypoint.displayName,
                    icon: L.divIcon(iconOptions),
                    opacity: waypoint.iconHidden ? 0 : 1
                }).bindPopup(waypoint.displayName, {
                    offset: new L.Point(0, -30)
                });

                markers.push(marker);
            }

            featureGroup = L.featureGroup([polyline].concat(markers));

            return featureGroup;
        };

        self.remove = function () {
            if (self.featureGroup) {
                self.featureGroup.clearLayers();
            }
        };

        self.hide = function () {
            self.remove();
        };

        self.allowEdit = function () {
            self.isEditing = true;

            // redraw with dragging enabled
            self.remove();
            self.addToMap();
        };

        self.preventEdit = function () {
            self.isEditing = false;
            self.addToMap();
        };

        self.show = function () {
            self.addToMap();
        };
    };

    return control;
});

